"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedoMigrationModal = exports.RedoMigrationModalContent = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const nice_modal_react_1 = __importStar(require("@ebay/nice-modal-react"));
const AccountContext_1 = require("contexts/AccountContext");
const redo_migration_modal_constants_1 = require("./redo-migration-modal.constants");
const RedoMigrationModalContent = ({ open, onDismiss, onViewInRedo }) => {
    if (!open) {
        return null;
    }
    return (react_1.default.createElement(polaris_1.Modal, { onClose: onDismiss, open: open, secondaryActions: [
            {
                content: 'Continue in Malomo',
                onAction: onDismiss
            }
        ], title: 'Your account has been transitioned to Redo' },
        react_1.default.createElement(polaris_1.Modal.Section, null,
            react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' },
                react_1.default.createElement(polaris_1.Link, { onClick: onViewInRedo }, "View my data in Redo \u2192")))));
};
exports.RedoMigrationModalContent = RedoMigrationModalContent;
exports.RedoMigrationModal = nice_modal_react_1.default.create(() => {
    const modal = (0, nice_modal_react_1.useModal)();
    const { account } = (0, AccountContext_1.useAccount)();
    const handleDismiss = (0, react_1.useCallback)(() => {
        if (account === null || account === void 0 ? void 0 : account.id) {
            (0, redo_migration_modal_constants_1.dismissRedoMigrationNotice)(account.id);
        }
        modal.remove();
    }, [account === null || account === void 0 ? void 0 : account.id, modal]);
    const handleViewInRedo = (0, react_1.useCallback)(() => {
        window.open(env.REDO_APP_URL, '_blank', 'noopener,noreferrer');
        handleDismiss();
    }, [handleDismiss]);
    return (react_1.default.createElement(exports.RedoMigrationModalContent, { onDismiss: handleDismiss, onViewInRedo: handleViewInRedo, open: modal.visible }));
});
